module.exports = __webpack_public_path__ + "static/media/toast-error.9688a165.svg";